import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';

import CiberManagement from 'views/CiberManagement/CiberManagement';
import ProfessionalServiceManagement from 'views/ProfessionalServiceManagement/ProfessionalServiceManagement';
import GcpManagement from 'views/GcpManagement/GcpManagement';
import { DependencyManagementView } from 'views/DependenciesManagement/DependencyManagementView';
import ProvidersManagement from 'views/ProvidersManagement/ProvidersManagement';
import HardwareManagement from 'views/HardwareManagement/HardwareManagement';

const UsersManagement = Loadable(lazy(() => import('views/UsersManagement')));
const NotificationManagement = Loadable(lazy(() => import('views/NotificationManagement')));

const AdminRouters = [
  {
    path: 'users-management',
    element: <UsersManagement />
  },
  {
    path: 'providers-management',
    element: <ProvidersManagement />
  },
  {
    path: 'notifications-management',
    element: <NotificationManagement />
  },
  {
    path: 'dependencies-management',
    element: <DependencyManagementView />
  },
  {
    path: 'google-cloud',
    element: <GcpManagement />
  },
  {
    path: 'hardware',
    element: <HardwareManagement />
  },
  {
    path: 'cybersecurity',
    element: <CiberManagement />
  },
  {
    path: 'professional-works',
    element: <ProfessionalServiceManagement />
  }
];

export default AdminRouters;
